export default[ //Students
      {
        path: "ChO71OpG7tVVBKTuI2O0",
        children: [
          {
            path: "YNoXHyC6Ct",
            name: "bece25.students",
            meta: {
              title: "BECE 2025 students",
              authRequired: true,
            },
            component: () => import("@/views/bece/twf/student/index.vue"),
          },
          {
            path: "YNoXHyC6Ctrcwecwwefew",
            name: "create.student.bece25",
            meta: {
              title: "Create BECE 2025 student",
              authRequired: true,
            },
            component: () => import("@/views/bece/twf/student/create.vue"),
          },
          {
            path: "BtKNdN9Vg8/:str?",
            name: "bece25.student",
            meta: {
              title: "View BECE 2025 student",
            },
            component: () => import("@/views/bece/twf/student/view.vue"),
          },
          {
            path: "OnqQfkp/:str?",
            name: "bece25.studentedit",
            meta: {
              title: "Edit BECE 2025 student",
            },
            component: () => import("@/views/bece/twf/student/edit.vue"),
          },
          // {
          //   path: "generate",
          //   name: "generateExamNumber",
          //   meta: {
          //     title: "GENERATE EXAM NUMBER",
          //   },
          //   component: () =>
          //     import("../views/bece/student_management/generateExamNumber.vue"),
          // },
          // {
          //   path: "export",
          //   name: "exportStudents",
          //   meta: {
          //     title: "EXPORT STUDENTS",
          //   },
          //   component: () =>
          //     import("../views/bece/student_management/exportStudents.vue"),
          // },
        ],
      },]